export default "__VITE_ASSET__DfPeBnLQ__"